import Img1 from './assets/1.jpg';
import Img2 from './assets/2.jpg';
import Img3 from './assets/3.jpg';
import Img4 from './assets/4.jpg';
import Img5 from './assets/5.jpg';
import Img6 from './assets/6.jpg';
import Img7 from './assets/7.jpg';
import Img8 from './assets/8.jpg';

export default [
  {
    img: Img1,
    title: '03-03-2018',
    description: `Janssen asked “will you be my girlfriend?” and Raina said YES!`,
  },
  {
    img: Img2,
    title: '03-06-2019',
    description: `We were spending our first holiday together to Jogja as a couple.`,
  },
  {
    img: Img3,
    title: '26-12-2019',
    description: `First time overseas together!`,
  },
  {
    img: Img4,
    title: '22-11-2020',
    description: `“Will you marry me?” Janssen pooped the questions with ring on his hand and Raina said YES.`,
  },
  {
    img: Img5,
    title: '20-12-2020',
    description: `Kalungan Day of Janssen & Raina.`,
  },
  {
    img: Img6,
    title: `23-04-2021`,
    description: `Went to Sumba for pre-wedding photoshoot.`,
  },
  {
    img: Img7,
    title: `21-11-2021`,
    description: `Sangjit Day! It’s a proposal for marriage by Janssen’s family to the Raina’s family.`,
  },
  {
    img: Img8,
    title: `19-12-2021`,
    description: `And finally we are getting married soon! SAVE THE DATE ❤`,
  },
];
